export const INTEREST_SERIES_DEFINITION_SLICE_NAME = 'interetsSeriesDefinition';
